import * as React from 'react';
import { ControlIcons } from 'owa-control-icons';
import { getErrorString, isAnyError } from '../selectors/errorSelectors';
import { getFileProviderName } from '../selectors/fileProviderSelectors';
import { getIconForFileProvider } from 'owa-fileprovider-icon';
import { getOwaCommonStrings } from 'owa-strings/owa-common-strings';
import { getSelectedFolderName } from '../selectors/selectedFolderSelectors';
import { Icon } from 'office-ui-fabric-react/lib/Icon';
import { isLoading } from '../selectors/loadingSelectors';
import { observer } from 'mobx-react';
import { Spinner, SpinnerSize } from 'office-ui-fabric-react/lib/Spinner';

const styles = require('./ProviderFolderView.scss');
const classNames = require('classnames');

export const ProviderFolderView = observer(function ProviderFolderView() {
    const folderName = getSelectedFolderName();
    const fileProviderName = getFileProviderName();
    const loading = isLoading();

    return (
        <div className={styles.container}>
            <div className={styles.icon}>
                {loading ? <Spinner size={SpinnerSize.medium} /> : getIcon()}
            </div>
            <div className={loading ? styles.loadingContent : styles.content}>
                {loading ? (
                    getOwaCommonStrings().connectingToOneDriveText
                ) : (
                    <FileProviderView fileProviderName={fileProviderName} folderName={folderName} />
                )}
            </div>
        </div>
    );
});

const FileProviderView = observer(function FileProviderView(props: {
    fileProviderName: string;
    folderName: string;
}) {
    const errorString = isAnyError() ? getErrorString() : null;
    return (
        <>
            <div className={styles.providerName}>{props.fileProviderName}</div>
            {errorString ? (
                <div className={classNames(styles.folderInfo, styles.errorInfo)}>
                    <Icon className={styles.folderIcon} iconName={ControlIcons.Error} />
                    {errorString}
                </div>
            ) : (
                <div className={styles.folderInfo}>
                    <Icon className={styles.folderIcon} iconName={ControlIcons.FabricFolder} />
                    {props.folderName}
                </div>
            )}
        </>
    );
});

function getIcon(): JSX.Element {
    return getIconForFileProvider(ControlIcons.OneDriveLogo, styles.oneDriveIcon);
}
